import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "80%",
    margin: "0 auto",
    textAlign: "center",
    marginTop: "-100px",
  },
  back: { display: "flex", justifyContent: "flex-start" },
  profileTitle: {
    marginBottom: 5,
  },
  listBox: {
    width: "60%",
    flexDirection: "row",
    textAlign: "left",
    alignItems: "center",
    margin: "0 auto",
    marginTop: 2,
  },
  mb: {
    marginBottom: 2,
  },
  w30: {
    width: "30%",
  },
  pwstyle: {
    position: "relative",
    width: "100%",
  },
  iconButton: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
  },
  buttonArea: {
    justifyContent: "center",
    marginTop: 10,
  },
  button: {
    marginTop: 10,
  },
};
